import { render, staticRenderFns } from "./EcommerceReport.pug?vue&type=template&id=201ab637&lang=pug&external"
import script from "./EcommerceReport.js?vue&type=script&lang=js&external"
export * from "./EcommerceReport.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports